import React from 'react';
import {
  Radio,
  RadioGroup,
  Typography,
  FormControlLabel,
  Box,
  Card,
} from '@material-ui/core';
import { Button, useStyles } from './styles';

const Questions = (props) => {
  const {
    questions,
    totalPages,
    currentPage,
    onChangePage,
    onChangeAnswer,
    onSubmitQuestions,
  } = props;
  const classes = useStyles();
  return (
    <>
      <form onSubmit={onSubmitQuestions} className={classes.root}>
        <Card className={classes.card}>
          {questions?.map((question) => (
            <Box key={question.id} className={classes.container}>
              <Box className={classes.questionContainer}>
                <Typography className={classes.question}>
                  {question.nombre}
                </Typography>
              </Box>

              <RadioGroup
                row
                key={question.nombre}
                onChange={(event) => onChangeAnswer(event, `pregunta_${question.id}`, question.id)}
                value={question.respuesta || ''}
              >
                {question?.respuestas.map((respuesta) => (
                  <FormControlLabel
                    key={respuesta.id}
                    value={respuesta.id}
                    control={<Radio style={{ color: '#FFA500' }} />}
                    label={respuesta.nombre}
                  />
                ))}
              </RadioGroup>
              <Box>
                <Button
                  disabled={currentPage === 1}
                  onClick={() => onChangePage('prev')}
                >
                  ANTERIOR
                </Button>

                {currentPage !== totalPages ? (
                  <Button
                    disabled={!question.respuesta}
                    onClick={() => onChangePage('next')}
                  >
                    SIGUIENTE
                  </Button>
                ) : (
                  <Button disabled={!question.respuesta} type="submit">
                    ENVIAR
                  </Button>
                )}
              </Box>
            </Box>
          ))}
        </Card>
      </form>
    </>
  );
};

export default Questions;
